export default __webpack_public_path__ + "static/media/casaduana_gratis.89da4f2f.png";